export var AccountTypes;
(function (AccountTypes) {
    AccountTypes["SelfServiceAccount"] = "Self Service Account";
    AccountTypes["ManagedAccount"] = "Managed Account";
})(AccountTypes || (AccountTypes = {}));
